import React from 'react'
import ContentLoader from 'react-content-loader'
import { Card, Icon } from 'antd'
import ImgWrapper from '../ImgWrapper'
import styles from './index.scss'
import { isNumber } from 'util'
import { downloadData } from 'services/api/course'
import smallDefaultCover from 'assets/images/small_cover.png'
import middleDefaultCover from 'assets/images/middle_cover.png'

enum DataType {
  video = '1000101',
  text = '1000102',
  audio = '1000103',
}

interface Props {
  type: string
  cover: string
  bodyStyle?: React.CSSProperties
  dataType?: string
  title?: string
  watch?: number
  time?: number
  collect?: number
  loading?: boolean
  course?: boolean
  durl?: string
  id?: number
}

const TYPES = ['small', 'middle']

const BlockCard: React.SFC<Props> = ({
  type,
  cover,
  bodyStyle,
  time = 0,
  title = '',
  watch,
  dataType = '1000101',
  collect,
  loading = false,
  course = false,
  durl,
  id,
}) => {
  const isSmall = !TYPES.indexOf(type)
  const coverHeader = isSmall ? 124 : 180

  const handleDownload = async (e, url) => {
    e.stopPropagation()
    await downloadData(id)
    window.open(url)
  }

  cover = cover || (isSmall ? smallDefaultCover : middleDefaultCover)

  const studied = (num: number) => (
    <span style={{ color: '#999', fontSize: 14 }}>
      {isNumber(num) && `${num}人学过`}
    </span>
  )

  const other = (num: number, _type: string, url?: string) => (
    <>
      <span className="download_tip" style={{ color: '#999', fontSize: 14 }}>
        {num > 9999 ? `9999+` : `${num}`}
        <a
          className="download_btn"
          onClick={e => url && handleDownload(e, url)}
        >
          {_type}
        </a>
      </span>
    </>
  )

  const coverRender = _type =>
    _type === DataType.video || _type === DataType.audio ? (
      <div className={styles.cover}>
        <ImgWrapper height={coverHeader} src={cover} loading />
        <div className="play-icon" />
      </div>
    ) : (
      <ImgWrapper height={coverHeader} src={cover} loading />
    )
  const tagRender = _type => {
    return (
      <div className={styles.tag}>
        <span>
          {
            [
              '压缩包',
              '视频',
              '文章',
              '音频',
              '专题',
              '外链',
              'PPT',
              'WORD',
              'PDF',
              'EXCEL',
              '图片',
            ][
              [
                DataType.video,
                DataType.text,
                DataType.audio,
                '1000104',
                '1000105',
                '1100101',
                '1100102',
                '1100103',
                '1100104',
                '1100105',
              ].indexOf(_type) + 1
            ]
          }
        </span>
      </div>
    )
  }
  const timeRender = _time => (
    <span style={{ color: '#999', fontSize: 14 }}>
      <Icon type="clock-circle-o" style={{ marginRight: 8 }} />
      {_time} 分
    </span>
  )

  const MidLoading = (
    <ContentLoader
      height={310}
      width={290}
      speed={2}
      primaryColor="#f5f5f5"
      secondaryColor="#ecebeb"
    >
      <rect x="0" y="1.05" rx="0" ry="0" width="290" height="180" />
      <rect x="16" y="200" rx="0" ry="0" width="259" height="12" />
      <rect x="16" y="220" rx="0" ry="0" width="259" height="12" />
      <rect x="16" y="270.05" rx="0" ry="0" width="70" height="12" />
    </ContentLoader>
  )

  const SmallLoading = (
    <ContentLoader
      height={240}
      width={224}
      speed={2}
      primaryColor="#f5f5f5"
      secondaryColor="#ecebeb"
    >
      <rect x="0" y="1" rx="0" ry="0" width="224" height="124" />
      <rect x="9" y="139" rx="0" ry="0" width="203" height="12" />
      <rect x="9" y="159" rx="0" ry="0" width="203" height="12" />
      <rect x="9" y="199" rx="0" ry="0" width="70" height="12" />
    </ContentLoader>
  )

  const CardContent = (
    <>
      <div className="title" title={title}>
        {title}
      </div>
      <div>
        <div
          style={{
            minHeight: 18,
            maxHeight: 18,
            margin: '2px 0 8px',
            textAlign: 'left',
          }}
        >
          {tagRender(dataType)}
        </div>
        <div className="other">
          {course ? other(watch, '预览') : studied(watch)}
          {course
            ? other(collect, '下载', durl)
            : dataType !== '1000104' && dataType !== '1000105'
              ? timeRender(time)
              : null}
        </div>
      </div>
    </>
  )

  const MidCard = ({ loading: _loading }) =>
    _loading ? (
      <div className={styles.cardMid}>{MidLoading}</div>
    ) : (
      <Card
        bordered={false}
        hoverable
        cover={coverRender(dataType)}
        className={styles.cardMid}
        bodyStyle={{ padding: 12, ...bodyStyle }}
      >
        <div className={styles.meta}>{CardContent}</div>
      </Card>
    )

  const SmallCard = ({ loading: _loading }) =>
    _loading ? (
      <div className={styles.cardSmall}>{SmallLoading}</div>
    ) : (
      <Card
        bordered={false}
        hoverable
        cover={coverRender(dataType)}
        className={styles.cardSmall}
        bodyStyle={{ padding: 12, ...bodyStyle }}
      >
        <div className={styles.description}>{CardContent}</div>
      </Card>
    )

  return isSmall ? (
    <SmallCard loading={loading} />
  ) : (
    <MidCard loading={loading} />
  )
}

export default BlockCard
